import React from "react"
import { useTranslation } from "react-i18next"

import { Hint } from "shared/ui/hint/Hint"
import { IconName } from "shared/ui/icon/__generated__/IconName"

export interface RoomFormHintProps {
  onClose: () => void
}

export const RoomFormHint = React.memo(({ onClose }: RoomFormHintProps) => {
  const { t } = useTranslation()

  return (
    <Hint.Root className="room-form__hint" data-testid="room-form-hint">
      <Hint.Icon name={IconName.INFO} />
      <Hint.Content>
        <Hint.Title>{t("RoomForm.Hint.Title")}</Hint.Title>

        <Hint.Section>
          <Hint.SectionHeader>
            {t("RoomForm.Hint.BasicData.Header")}
          </Hint.SectionHeader>
          <Hint.Text>{t("RoomForm.Hint.BasicData.Text")}</Hint.Text>
        </Hint.Section>

        <Hint.Section>
          <Hint.SectionHeader>
            {t("RoomForm.Hint.OptionalData.Header")}
          </Hint.SectionHeader>
          <Hint.Text>{t("RoomForm.Hint.OptionalData.Text")}</Hint.Text>
        </Hint.Section>
      </Hint.Content>
      <Hint.Close onClick={onClose} aria-label={t("RoomForm.Hint.Close")} />
    </Hint.Root>
  )
})

RoomFormHint.displayName = "RoomFormHint"
